import { render, staticRenderFns } from "./ModuleElementList.vue?vue&type=template&id=6b8267b6"
import script from "./ModuleElementList.vue?vue&type=script&lang=js"
export * from "./ModuleElementList.vue?vue&type=script&lang=js"
import style0 from "./ModuleElementList.vue?vue&type=style&index=0&id=6b8267b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports